export const billsData = {
title:"Rechnungen"
};